module Client.IllyAdmin.Actions.Types

open Client

type AdminActionKey =
    | BrowseConfigMetadata
    | BrowseHilos
    | BrowseLoggers
    | ViewRevocations

module AdminActionKey =
    let options =
        [
            BrowseConfigMetadata
            BrowseHilos
            BrowseLoggers
            ViewRevocations
        ]

type ActionEvent =
    | AppError of AppError
    | BackToGrid of notification: string option

[<RequireQualifiedAccess>]
type ActionGroup =
    | Login
    | Config
    | Caches

module ActionGroup =
    let toString =
        function 
        | ActionGroup.Login -> "Login"
        | ActionGroup.Config -> "Configuration"
        | ActionGroup.Caches -> "Caches"

type AdminActionMeta =
    {
        Key: AdminActionKey
        Title: string
        Description: string
        Group: ActionGroup
    }

module AdminActionMeta =
    let create key title description group =
        {
            Key = key
            Title = title
            Description = description
            Group = group
        }